module.exports = WeakMap;